<template>
  <div :class="{'flex-wrap table-filter-item': label }">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      :class="{'w100': !label}"
      v-model="valueBackup"
      filterable
      remote
      :placeholder="placeholder"
      :clearable="clearable"
      :multiple="multiple"
      :size="size"
      :remote-method="search"
      @change="handleChange"
    >
      <el-option
        v-for="item in listBackup"
        :key="item.id"
        :label="item.card_charge_type_name"
        :value="item.id"
        class="price-option"
        :disabled="!!item.is_disabled"
      >
        <div class="price-item">
          <div v-html="getKeywordHtml(`${item.card_type_name} - ${item.card_charge_type_name} - ${item.price_name}`)" class="item"></div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { index } from '@/api/card-charge-type';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入套餐名称进行搜索',
    },
    list: {
      type: Array,
      default: () => [],
    },
    multiple: Boolean,
    clearable: Boolean,
    ids: {
      type: Array,
      default: () => [],
    },
    cardTypeId: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    valueBackup: '',
    listBackup: [],
    keyword: '',
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
    listBackup: {
      handler: function(listBackup) {
        if (JSON.stringify(listBackup) !== JSON.stringify(this.list)) this.$emit('listChange', listBackup);
      },
      deep: true,
    },
    cardTypeId() {
        this.search(this.keyword);
    },
  },
  methods: {
    getKeywordHtml(words) {
      words = `${words}`.replace(
        RegExp(this.keyword, 'i'),
        (keyword) => `<span class='primary-color'>${keyword}</span>`,
      );
      return words;
    },
    async initList() {
      const { isError, data } = await index({
        card_charge_type_ids: this.ids,
        card_type_id: this.cardTypeId,
        is_only_list: 1,
        size: 20,
      });
      if (!isError) this.listBackup = data || [];
    },
    async search(keyword = '') {
      if (!keyword) {
        if (this.multiple) {
          if (this.valueBackup.length) return;
        } else {
          if (this.valueBackup) return;
        }
      }

      keyword = keyword || '';
      this.keyword = keyword;
      const { isError, data } = await index({
        keyword,
        card_type_id: this.cardTypeId,
        is_only_list: 1,
        size: 20,
      });
      if (!isError) this.listBackup = data || [];
    },
    handleChange(valueBackup) {
      if (!this.multiple) {
        for (let item of this.listBackup) {
          if (item.id === valueBackup) return this.$emit('change', item);
        }
        return;
      }

      if (typeof valueBackup !== 'object') return;

      const checkedIds = [];
      valueBackup.forEach((checkedId) => {
        this.listBackup.forEach((listItem) => {
          if (listItem.id === checkedId) checkedIds.push(checkedId);
        });
      });
      this.$emit('change', checkedIds);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }

    if (this.list.length) return this.listBackup = this.list;
    this.initList();
  },
};
</script>

<style scoped>
.price-option {
  display: flex;
  align-items: center;
  height: 40px;
}

.price-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.item {
  height: 25px;
  line-height: 25px;
}
</style>
